import LayoutNoFooter from '@/page/layout/index'

export default [
    {
        path: '/guifan',
        name: 'guifan',
        component: LayoutNoFooter,
        children: [
            {
                path: 'ai',
                name: 'ai',
                component: () => import(/* webpackChunkName: "views" */ '@/views/index/ai.vue'),
                meta: {
                    title: '墅小督',
                    isAuth:false,
                    dingConfig:false
                }
            },
            {
                path: 'startup',
                name: 'startup',
                component: () => import(/* webpackChunkName: "views" */ '@/views/index/startup.vue'),
                meta: {
                    title: '启动页',
                    isAuth:false,
                    dingConfig:false
                }
            },
            {
                path: 'startup2',
                name: 'startup2',
                component: () => import(/* webpackChunkName: "views" */ '@/views/index/startup2.vue'),
                meta: {
                    title: '启动页',
                    isAuth:false,
                    dingConfig:false
                }
            },
            {
                path: 'rules',
                name: 'guifan-rules',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/guifan/rules'),
                props: route => ({
                }),
                meta: {
                    title: '家风家训',
                    isAuth: false,
                }
            },
            {
                path: 'standards',
                name: 'guifan-standards',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/guifan/standards'),
                props: route => ({
                }),
                meta: {
                    title: '工作规范',
                    isAuth: false,
                }
            },
            {
                path: 'home',
                name: 'guifan-home',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/guifan/home'),
                props: route => ({
                }),
                meta: {
                    title: '督学小家',
                    isAuth: false,
                }
            },
            {
                path: 'home/detail',
                name: 'guifan-home-detail',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/guifan/homeDetail'),
                props: route => ({
                }),
                meta: {
                    title: '督学小家',
                    isAuth: false,
                }
            }
        ]
    },
]
